import React from 'react';
import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import MenuNavContainer from "./components/shared/menuNavContainer";
import { RouteErrorBoundary } from "./components/shared/errorBoundary";

import { Login } from "./components/account/login";
import { NotFoundPage } from "./components/shared/notFoundPage";
import { Dashboard } from "./components/main/dashboard";
import { Patient } from './components/main/patient';
import { Search } from './components/main/search';
import { Contestations } from './components/main/contestations';
import { Contact } from './components/main/contact';
import { MyAccount } from './components/main/myAccount';
import { FilesList } from './components/main/filesList';
import { Doctors } from './components/main/doctors';
import { Raport } from './components/main/raport';
import { Logout } from './components/main/logout';
import { Consultation } from './components/main/consultation';
import { MMRecord } from './components/main/mmRecord'
import { Preauthorization } from './components/main/preauthorization';
import { MMPreauthorization } from './components/main/mmPreauthorization';
import { PartnerList } from './components/main/partnerList';
import { PatientAdd } from './components/main/patientAdd';
import { Partner } from './components/account/partner';

const App = (props) => {
    return (<Router>
        <MenuNavContainer>
            <RouteErrorBoundary>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/dashboard/*" element={<Dashboard />}>
                        <Route path="cautare-pacient" element={<Patient />} />
                        <Route path="cautare" element={<Search />} />
                        <Route path="contestatii" element={<Contestations />} />
                        <Route path="selectie-partener" element={<PartnerList />} />
                        <Route path="adauga-pacient" element={<PatientAdd />} />

                        <Route path="raport-consultatii-nefinalizate" element={<Raport title="Consultatii nefinalizate" />} />
                        <Route path="raport-consultatii-mm-nefinalizate" element={<Raport title="Consultatii MM nefinalizate" />} />
                        <Route path="raport-servicii-respinse" element={<Raport title="Servicii respinse"/>} />
                        <Route path="raport-servicii-medicale-facturare" element={<Raport title="Servicii medicale pentru facturare" haveLocation={true} />} />
                        <Route path="raport-fisa-mm-facturare" element={<Raport title="Fise MM pentru facturare" haveLocation={true} />}  />
                        <Route path="raport-servicii-medicale-prestate" element={<Raport title="Servicii medicale prestate"/>} />

                        <Route path="contul-meu" element={<MyAccount />} />
                        <Route path="medici" element={<Doctors />}  />
                        <Route path="lista-fisiere" element={<FilesList />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="consultatie" element={<Consultation />} />
                        <Route path="fisa-mm" element={<MMRecord />} />
                        <Route path="preautorizare" element={<Preauthorization />} />
                        <Route path="preautorizare-mm" element={<MMPreauthorization />} />
                    </Route>
                    <Route path="selectie-partener" element={<Partner />} />

                    <Route path="/404" element={<NotFoundPage />} />
                    <Route
                        path="*"
                        element={<Navigate to="/404" replace />}
                    />
                </Routes>
            </RouteErrorBoundary>
        </MenuNavContainer>
    </Router>);
}

export default App;